export default "__VITE_ASSET__PpfEzFx9__"